import { trace } from 'owa-trace';

// Global registry for external signout cleanup functions
// This allows owa-signout to register its cleanup without creating circular dependencies
let externalSignoutCleanup: (() => Promise<void>) | null = null;

/**
 * Registers an external signout cleanup function.
 * This is used by owa-signout package to register its comprehensive cleanup logic.
 */
export function registerExternalSignoutCleanup(cleanup: () => Promise<void>): void {
    externalSignoutCleanup = cleanup;
}

/**
 * Performs basic signout cleanup operations for MSAL-specific scenarios.
 *
 * This function executes any registered external cleanup (from owa-signout)
 * to preserve functionality for critical scenarios like Activity Timeout errors.
 */
export async function signoutCleanup(): Promise<void> {
    try {
        // Execute external signout cleanup if registered (e.g., from owa-signout)
        if (externalSignoutCleanup) {
            await externalSignoutCleanup();
        }

        trace.info('MSAL signout cleanup completed');
    } catch (error) {
        // Log error but don't throw to avoid breaking the signout flow
        trace.info('MSAL signout cleanup failure: ' + error);
    }
}
